var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions,"defaultSearchKey":_vm.defaultSearchKey,"group-actions":_vm.groupActions}})}
var staticRenderFns = []

export { render, staticRenderFns }